import React, { useEffect, useState } from 'react';
import '../styles.css';
import {
  Button,
  ButtonGroup,
  FormControlLabel,
  Switch,
  TextField,
} from '@material-ui/core';

const MonthBundle = (props: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [item, setItem] = useState({
    ...props.item,
    discount: props.item.discount * 100,
  });

  const handleChange = (e: any) => {
    if (e.target.name === 'discount') {
      if (
        Number(e.target.value) <= 100 &&
        Number(e.target.value) >= 0 &&
        !String(e.target.value).includes('-') &&
        !String(e.target.value).includes('+')
      ) {
        setItem({
          ...item,
          [e.target.name]: Number(e.target.value),
        });
      } else if (!String(e.target.value).length) {
        setItem({
          ...item,
          [e.target.name]: 0,
        });
      }
      return;
    } else {
      setItem({
        ...item,
        [e.target.name]: e.target.value,
      });
    }
  };
  const handleChangeStatus = (e: any) => {
    setItem({ ...item, active: e.target.checked });
  };
  const handleChangeBonusStatus = (e: any) => {
    setItem({
      ...item,
      discountActive: e.target.checked,
    });
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    const res = await props.update(props.subscriptionModelId, {
      itemIndex: props.index,
      month: {
        ...item,
      },
    });
    console.log(res);

    console.log('updated');
    setIsEdit(false);
    setIsLoading(false);
  };

  useEffect(() => {
    setItem({ ...props.item, discount: props.item.discount * 100 });
  }, [props.item]);
  return (
    <div className={`month-bundle${isEdit ? ' edit' : ''}`}>
      {isEdit ? (
        <React.Fragment>
          <div className='content'>
            <div className='form-row'>
              <div className='month-bundle-inner'>
                <FormControlLabel
                  control={
                    <Switch
                      checked={item.active}
                      onChange={handleChangeStatus}
                    />
                  }
                  label={item.active ? 'Active' : 'Disabled'}
                />
              </div>
              <div className='month-bundle-inner'>
                <p>
                  Period: <span>{item.month}</span>
                </p>
              </div>
            </div>
            <div className='form-row'>
              <div className='month-bundle-inner'>
                <FormControlLabel
                  control={
                    <Switch
                      checked={item.discountActive}
                      onChange={handleChangeBonusStatus}
                    />
                  }
                  label={item.discountActive ? 'Active' : 'Disabled'}
                />
              </div>
              <div className='month-bundle-inner'>
                <TextField
                  className='edit-field'
                  size='small'
                  required
                  label='Discount'
                  name='discount'
                  type='number'
                  variant='outlined'
                  onChange={handleChange}
                  value={item.discount}
                  InputProps={{
                    inputProps: { step: 1, max: 100, min: 0 },
                  }}
                />
              </div>
              <div className='month-bundle-inner'>
                <TextField
                  className='edit-field'
                  size='small'
                  required
                  label='Text'
                  name='discountString'
                  variant='outlined'
                  onChange={handleChange}
                  value={item.discountString}
                />
              </div>
            </div>
          </div>
          <div className='buttons'>
            <ButtonGroup variant='contained' aria-label='outlined button group'>
              <Button
                size='small'
                color='primary'
                onClick={handleSubmit}
                disabled={isLoading}
              >
                Save
              </Button>
              <Button
                size='small'
                color='primary'
                onClick={() => {
                  setIsEdit(false);
                  setItem(props.item);
                }}
                disabled={isLoading}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </div>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div className='content'>
            <div className='month-bundle-inner'>
              <p>Month Status: </p>
              <p>{item.active ? 'Active' : 'Disabled'}</p>
            </div>
            <div className='month-bundle-inner'>
              <p>Period:</p>
              <p>{item.month}</p>
            </div>
            <div className='month-bundle-inner'>
              <p>Discount Status: </p>
              <p>{item.discountActive ? 'Active' : 'Disabled'}</p>
            </div>
            <div className='month-bundle-inner'>
              <p> Discount: </p>
              <p>{item.discount} %</p>
            </div>
            <div className='month-bundle-inner'>
              <p>Discount Text:</p>
              <p>
                {item.discountString.length === 0 && !isEdit
                  ? 'None'
                  : item.discountString}
              </p>
            </div>
          </div>
          <div className='buttons'>
            <ButtonGroup
              variant='contained'
              aria-label='outlined button group'
              disabled={isLoading}
            >
              <Button
                size='small'
                color='primary'
                disabled={item.month === 1}
                onClick={() => {
                  setIsEdit(true);
                }}
              >
                Edit
              </Button>
            </ButtonGroup>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default MonthBundle;
